/**
 * Toast Redux Selectors
 */

/**
 * Get all active toasts
 * @param {Object} state - Redux state
 * @returns {Array} Array of toast objects
 */
export const toastsSelector = (state) => state.toast?.toasts || [];

/**
 * Get toast count
 * @param {Object} state - Redux state
 * @returns {number} Number of active toasts
 */
export const toastCountSelector = (state) => toastsSelector(state).length;

/**
 * Check if there are any active toasts
 * @param {Object} state - Redux state
 * @returns {boolean} True if there are active toasts
 */
export const hasToastsSelector = (state) => toastCountSelector(state) > 0;

/**
 * Get a specific toast by ID
 * @param {Object} state - Redux state
 * @param {string} id - Toast ID
 * @returns {Object|undefined} Toast object or undefined
 */
export const toastByIdSelector = (state, id) => 
    toastsSelector(state).find(t => t.id === id);

export default {
    toastsSelector,
    toastCountSelector,
    hasToastsSelector,
    toastByIdSelector,
};

